import Image from "next/image";
import React from "react";

const stats = [
  {
    value: "10+",
    label: "Years of Innovation",
    color: "#0086E6",
  },
  {
    value: "250+",
    label: "Global Client Served",
    color: "#8ABC00",
  },
  {
    value: "30+",
    label: "Countries Reached",
    color: "#0086E6",
  },
];

interface ResponsiveImages {
  desktop?: string;
  ipad?: string;
  mobile?: string;
}

interface SubmenuLeftBottomProps {
  images?: ResponsiveImages;
}

const SubmenuLeftBottom = ({ images }: SubmenuLeftBottomProps) => {
  //  NOTE:( >>>>>>>   temporary hidden another boxes, you can remove "hidden" class to show...
  if (images?.desktop) {
    // Ipad/mobile variants fall back to the desktop image in the CMS layer,
    // so all three are guaranteed here once `desktop` is set.
    return (
      <div className="left-bottom xl:mt-[24px] mt-[55px]">
        <Image
          src={images.mobile || images.desktop}
          alt=""
          width={1320}
          height={104}
          className="w-full h-auto object-contain md:hidden"
        />
        <Image
          src={images.ipad || images.desktop}
          alt=""
          width={1320}
          height={104}
          className="w-full h-auto object-contain hidden md:block lg:hidden"
        />
        <Image
          src={images.desktop}
          alt=""
          width={1320}
          height={104}
          className="w-full h-auto object-contain hidden lg:block"
        />
      </div>
    );
  }

  return (
    <>
      {/* ======= Services ===========*/}

      <div className="left-bottom xl:mt-[24px] mt-[18px] border-1 border-[#B0D9F7] xl:p-[25px]  p-[12px] ">
        <div className="flex gap-[10px] justify-between items-center flex-wrap">
          <div className="xl:max-w-[170px] max-w-[120px] w-full xl:pr-[24px] pr-[15px]">
            <Image
              src="/images/clutch-logo.svg"
              alt=""
              width={40}
              height={40}
              className="w-[140px] h-[40px] object-contain"
            />
          </div>
          <div className="flex flex-col gap-[2px]  xl:px-[25px] md:px-[15px] py-[6px] border-l border-r border-[#E6F3FD]">
            <h5 className="xl:text-subtitle-3 text-[12px] font-bold text-[var(--color-primary-text)] !tracking-[1%]">
              TRooTech Business Solutions
            </h5>
            <div className="flex gap-[6px] items-center">
              <p className="text-subtitle-1 text-primary-text font-semibold leading-[100%]">
                4.8
              </p>
              <ul className="flex shrink-0 gap-[2px] items-center">
                {[1, 2, 3, 4, 5].map((item) => (
                  <li>
                    <Image
                      src="/images/start-icon.svg"
                      alt=""
                      width={18}
                      height={18}
                      className="w-[18px] h-[18px] object-contain"
                    />
                  </li>
                ))}
              </ul>
              <span className="text-[12px] text-secondary-text font-[400] leading-[100%]">
                500 Reviews
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-[8px] xl:max-w-[293px] md:max-w-[230px] max-w-[100%] w-full">
            <h5 className="text-subtitle-5  font-[600] text-[var(--color-primary-text)]">
              “Their communication,expertise and commitment set them apart.”
            </h5>
            <p className="text-[12px] text-secondary-text font-[400] leading-[100%]">
              - Head of Engineering, Logistics Company
            </p>
          </div>
        </div>
      </div>

      {/* ======= Industries ===========*/}
      <div className="left-bottom xl:mt-[24px] mt-[18px] border-1 border-[#B0D9F7] xl:p-[25px]  p-[12px] hidden ">
        <div className="flex gap-[10px] justify-between items-center flex-wrap">
          <div className="flex flex-col gap-[8px]  max-w-[300px] w-full">
            <h3 className="xl:text-[18px] text-[16px]  font-[700] text-[var(--color-primary-text)] leading-[130%]">
              Vetted, Certified & Trusted by Global Tech Giants{" "}
            </h3>
            <p className="text-[12px] font-[400] text-secondary-text leading-[110%]">
              There are many more to come.
            </p>
          </div>
          <div className="flex-1 flex xl:gap-[23px] gap-[15px] justify-end">
            {[
              "/images/great-place.svg",
              "/images/salesforce-logo.svg",
              "/images/aws.svg",
              "/images/sales-partner.svg",
            ].map((item) => (
              <Image
                src={item}
                alt=""
                width={70}
                height={40}
                className="w-auto h-[72px] object-contain"
                unoptimized
              />
            ))}
          </div>
        </div>
      </div>

      {/* =========== Software Solutions ======== */}
      <div className="left-bottom xl:mt-[24px] mt-[18px] border-1 border-[#B0D9F7] xl:p-[25px]  p-[12px] hidden">
        <div className="flex gap-[10px] justify-between items-center flex-wrap">
          <div className="flex flex-col gap-[8px]  max-w-[215px] w-full">
            <h3 className="xl:text-[18px] text-[16px]  font-[700] text-[var(--color-primary-text)] leading-[130%]">
              TRooTech in Numbers
            </h3>
            <p className="text-[12px] font-[400] text-secondary-text leading-[110%]">
              Milestones that define us
            </p>
          </div>
          <div className="flex-1 flex xl:gap-[23px] gap-[15px] justify-end">
            <ul className="flex flex-wrap">
              {stats.map((stat, index) => (
                <li
                  key={stat.label}
                  className={`flex-1 w-full flex flex-col gap-[2px] ${
                    index === 0
                      ? "pr-[12px]"
                      : "px-[12px] border-l border-[#E6F3FD]"
                  }`}
                >
                  <h5
                    className="xl:text-[24px] text-[18px] font-[700] leading-[130%]"
                    style={{ color: stat.color }}
                  >
                    {stat.value}
                  </h5>

                  <p className="xl:text-[16px] text-[14px] font-[400] text-primary-text leading-[110%]">
                    {stat.label}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* ======= About Us ===========*/}
      <div className="left-bottom xl:mt-[24px] mt-[18px] border-1 border-[#B0D9F7] xl:p-[25px]  p-[12px] hidden ">
        <div className="flex gap-[10px] justify-between items-center flex-wrap">
          <div className="xl:max-w-[170px] max-w-[120px] w-full xl:pr-[24px] pr-[15px]">
            <Image
              src="/images/glassdoor-logo.svg"
              alt=""
              width={40}
              height={40}
              className="w-[140px] h-[40px] object-contain"
            />
          </div>
          <div className="flex flex-col gap-[2px]  xl:px-[25px] md:px-[15px] py-[6px] border-l border-r border-[#E6F3FD]">
            <h5 className="xl:text-subtitle-3 text-[12px] font-bold text-[var(--color-primary-text)] !tracking-[1%]">
              TRooTech Business Solutions
            </h5>
            <div className="flex gap-[6px] items-center">
              <p className="text-subtitle-1 text-primary-text font-semibold leading-[100%]">
                4.8
              </p>
              <ul className="flex shrink-0 gap-[2px] items-center">
                {[1, 2, 3, 4, 5].map((item) => (
                  <li>
                    <Image
                      src="/images/start-icon.svg"
                      alt=""
                      width={18}
                      height={18}
                      className="w-[18px] h-[18px] object-contain"
                    />
                  </li>
                ))}
              </ul>
              <span className="text-[12px] text-secondary-text font-[400] leading-[100%]">
                500 Reviews
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-[8px] xl:max-w-[293px] md:max-w-[230px] max-w-[100%] w-full">
            <h5 className="text-subtitle-5  font-[600] text-[var(--color-primary-text)]">
              “Their communication,expertise and commitment set them apart.”
            </h5>
            <p className="text-[12px] text-secondary-text font-[400] leading-[100%]">
              - Head of Engineering, Logistics Company
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubmenuLeftBottom;
